import _ from 'lodash';
import {VALIDATION_ERRORS, EVENTS} from 'common/domain/constants';

class RequestFormSickLeaveReportsController {

  constructor($timeout, $rootScope, floatingActionButtonsService) {
    'ngInject';
    this.timeout = $timeout;
    this.rootScope = $rootScope;
    this.onlyNumbersPattern = new RegExp('^[0-9]*$');
    this.floatingActionButtonsService = floatingActionButtonsService;
  }

  _getNextOrder() {
    let orders = _.map(this.sickLeaveReports, 'order');
    orders = _.map(orders, Number);
    return _.max(orders) + 1;
  }

  addSickLeaveReport(sickLeaveReports) {
    this.timeout(() => {
      this.floatingActionButtonsService.run();
    });
    const order = this._getNextOrder();
    const date = this.getSickLeaveReportDate();
    const sickPartDate = date; // View purposes
    const disabled = false;
    sickLeaveReports.push({order, date, sickPartDate, disabled});
    this._validateReportDate(date);
    this._medicalPartAdded();
  }

  _medicalPartAdded() {
    this.rootScope.$broadcast(EVENTS.BUTTON_SICK_LEAVE_REPORTS_DISABLED, {});
  }

  /**
   * If we're trying to create a report on the same date that the sick date, force to create it the
   * next day at least.
   */
  getSickLeaveReportDate() {
    return this.startDate;
  }

  getIconClass() {
    return {
      'glyphicon glyphicon-plus-sign': !this.isMobileApp,
      'icon icon-plus-circle-big': this.isMobileApp
    };
  }

  validateReportOrder(input, order) {
    const orderNumber = parseInt(order, 10);
    const notDuplicated = this.reportOrderNotDuplicated(orderNumber);
    const validNumber = this.onlyNumbersPattern.test(order);
    const gtzero = orderNumber > 0;
    const valid = notDuplicated && validNumber && gtzero;
    input.$setValidity(VALIDATION_ERRORS.SICK_LEAVE_REPORTS.INVALID_ORDER, valid);
    input.$setDirty();
  }

  reportOrderNotDuplicated(order) {
    return this.sickLeaveReports.find(report => report.order === order) === undefined;
  }

  _validateReportDate(date) {
    const form = this.form;
    const formPosition = this.sickLeaveReports.length - 1;

    this.timeout(() => {
      const input = form[`sicknessLeaveReport${formPosition}`];
      const sickDate = this.getSickDate();
      const valid = date > sickDate;
      input.$setValidity(VALIDATION_ERRORS.SICK_LEAVE_REPORTS.INVALID_DATE, valid);
      input.$setDirty();
    });
  }

  /**
   * When change some datepicker, set the date to the report, but also if is at least greater than
   * sick date. Also, refresh view.
   */
  setLeaveReportDate($event, input, report) {
    const sickDate = this.getSickDate();
    const valid = $event.date > sickDate;
    input.$setValidity(VALIDATION_ERRORS.SICK_LEAVE_REPORTS.INVALID_DATE, valid);
    report.date = $event.date;
    report.sickPartDate = $event.date; // View purposes
  }

  /**
   * The sick date is always the date of the first part, because is the first one created.
   */
  getSickDate() {
    const originalSickReport = this.sickLeaveReports[0];
    return new Date(originalSickReport.absenceDate);
  }
}

export default RequestFormSickLeaveReportsController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormSickLeaveReports/requestFormSickLeaveReports.controller.js